import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Glance } from "../components/site/Glance";
import { About } from "../components/site/About";
import { Vision } from "../components/site/Vision";
import { WhyBhiwani } from "../components/site/WhyBhiwani";
import { Connectivity } from "../components/site/Connectivity";
import { SitePlan } from "../components/site/SitePlan";
import { Infrastructure } from "../components/site/Infrastructure";
import { Ecosystem } from "../components/site/Ecosystem";
import { Industries } from "../components/site/Industries";
import { Incentives } from "../components/site/Incentives";
import { Pricing } from "../components/site/Pricing";
import { Comparison } from "../components/site/Comparison";
import { Timeline } from "../components/site/Timeline";
import { ConstructionDiary } from "../components/site/ConstructionDiary";
import { Investors } from "../components/site/Investors";
import { ChannelPartners } from "../components/site/ChannelPartners";
import { Trust } from "../components/site/Trust";
import { BookingSteps } from "../components/site/BookingSteps";
import { Faq } from "../components/site/Faq";
import { Gallery } from "../components/site/Gallery";
import { BlogSection } from "../components/site/BlogSection";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { WhatsAppFloat } from "../components/site/WhatsAppFloat";
import { Seo } from "../components/Seo";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper" data-testid="home-page">
      <Seo
        title="BIDC — Bhiwani Industrial Development Cluster | Industrial Plots on NH-709, Bhiwani"
        description="Govt. of Haryana approved MSME industrial cluster on Bhiwani–Loharu Road, NH-709. 77 industrial plots, 10 plug & play sheds, complete infrastructure by Oct 2027. By Tirupati Developers."
        path="/"
        image="/assets/factory.webp"
      />
      <Header />
      <main>
        <Hero />
        <Glance />
        <About />
        <Vision />
        <WhyBhiwani />
        <Connectivity />
        <SitePlan />
        <Infrastructure />
        <Ecosystem />
        <Industries />
        <Incentives />
        <Pricing />
        <Comparison />
        <Timeline />
        <ConstructionDiary />
        <Investors />
        <ChannelPartners />
        <Trust />
        <BookingSteps />
        <Faq />
        <Gallery />
        <BlogSection />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
